import { Navigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import NotAllowedPage from '@pages/NotAllowedPage';

const ProtectedRoute = ({ children, role, doNotCheckPasswordChange = false }) => {
    const { loaded, isAuthenticated, isAdmin, isSuperAdmin, mustChangePassword } = useAuth();

    if (!loaded) {
        return null;
    }

    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    if (role === 'admin' && !isAdmin()) {
        return <NotAllowedPage />;
    }

    if (role === 'superadmin' && !isSuperAdmin()) {
        return <NotAllowedPage />;
    }

    if (!doNotCheckPasswordChange && mustChangePassword()) {
        return <Navigate to="/change-password" replace />;
    }

    return children;
};

export default ProtectedRoute;
